import api from './api';

export const pushService = {
    getPublicKey: () => api.get<{ publicKey: string }>('/push/vapid-public-key'),
    subscribe: (data: { endpoint: string; keys: { p256dh: string; auth: string }; workspaceId?: string }) =>
        api.post('/push/subscribe', data),
    unsubscribe: (endpoint: string) => api.post('/push/unsubscribe', { endpoint }),
};
